import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Box, Collapse, IconButton, Typography } from "__barrel_optimize__?names=Box,Collapse,IconButton,Typography!=!@mui/material";
import FormattedNewsText from "./FormattedNewsText";
export default function NewsCard(param) {
    let { item, translation, categoryLabel, isExpanded, onToggle } = param;
    return /*#__PURE__*/ _jsxs(Box, {
        sx: {
            border: "1px solid #FFAA00",
            borderRadius: "24px",
            overflow: "hidden",
            backgroundColor: "#FFF"
        },
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                sx: {
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: {
                        xs: "8px",
                        md: "20px"
                    },
                    padding: {
                        xs: "14px 16px",
                        md: "22px 42px"
                    }
                },
                children: [
                    /*#__PURE__*/ _jsxs(Box, {
                        sx: {
                            minWidth: 0,
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Typography, {
                                sx: {
                                    color: "#FFAA00",
                                    fontSize: {
                                        xs: "13px",
                                        md: "16px"
                                    },
                                    marginBottom: {
                                        xs: "10px",
                                        md: "16px"
                                    },
                                    textTransform: "uppercase",
                                    overflowWrap: "break-word",
                                    wordBreak: "break-word",
                                    lineHeight: 1.4
                                },
                                children: [
                                    item.date,
                                    " | ",
                                    categoryLabel
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                component: "h2",
                                sx: {
                                    color: "#000",
                                    fontSize: {
                                        xs: "18px",
                                        sm: "22px",
                                        md: "28px"
                                    },
                                    fontWeight: 400,
                                    marginBottom: "12px",
                                    overflowWrap: "break-word",
                                    wordBreak: "break-word",
                                    lineHeight: 1.3
                                },
                                children: translation.title
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                sx: {
                                    color: "#000",
                                    fontSize: {
                                        xs: "14px",
                                        md: "16px"
                                    },
                                    overflowWrap: "break-word",
                                    wordBreak: "break-word"
                                },
                                children: translation.subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(IconButton, {
                        "aria-label": isExpanded ? "News schlie\xdfen" : "News \xf6ffnen",
                        onClick: onToggle,
                        sx: {
                            color: "#FFAA00",
                            flexShrink: 0,
                            marginTop: {
                                xs: "-4px",
                                md: 0
                            },
                            padding: {
                                xs: "4px",
                                md: "8px"
                            }
                        },
                        children: isExpanded ? /*#__PURE__*/ _jsx(KeyboardArrowUpIcon, {
                            sx: {
                                fontSize: {
                                    xs: 32,
                                    md: 48
                                }
                            }
                        }) : /*#__PURE__*/ _jsx(KeyboardArrowDownIcon, {
                            sx: {
                                fontSize: {
                                    xs: 32,
                                    md: 48
                                }
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Collapse, {
                in: isExpanded,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ _jsx(Box, {
                    sx: {
                        backgroundColor: "#FFF",
                        padding: {
                            xs: "16px 16px 24px",
                            md: "34px 42px 48px"
                        },
                        whiteSpace: "pre-line",
                        overflowWrap: "break-word",
                        wordBreak: "break-word"
                    },
                    children: /*#__PURE__*/ _jsx(Typography, {
                        component: "div",
                        sx: {
                            color: "#000",
                            fontSize: {
                                xs: "14px",
                                md: "16px"
                            },
                            lineHeight: 1.55,
                            fontWeight: 400,
                            overflowWrap: "break-word",
                            wordBreak: "break-word",
                            "& a": {
                                overflowWrap: "anywhere",
                                wordBreak: "break-word"
                            }
                        },
                        children: /*#__PURE__*/ _jsx(FormattedNewsText, {
                            itemId: item.id,
                            content: translation.content,
                            boldTerms: translation.boldTerms,
                            italicTerms: translation.italicTerms
                        })
                    })
                })
            })
        ]
    });
}
